import React from "react";

function FormErrorMessage({ message }) {
  return <span className="text-red-500 text-sm">{message}</span>;
}

export default FormErrorMessage;
